import { gql } from 'graphql-request';

export const CACHE_CREATE_INVOICE_CUSTOM_FIELD_QUERY = gql`
  mutation CacheCreateInvoiceCustomField(
    $body: String
    $invoiceUuid: ID!
    $label: String!
    $location: String!
    $options: Json
    $order: Int
  ) {
    createInvoiceCustomField(
      input: {
        body: $body
        invoiceUuid: $invoiceUuid
        label: $label
        location: $location
        options: $options
        order: $order
      }
    ) {
      errors {
        fullMessages
      }
      record {
        body
        createdAt
        id
        invoiceId
        label
        location
        updatedAt
        userId
        uuid
      }
      recordId
      recordNanoId
      recordUuid
      status
    }
  }
`;
